/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './conf/__root'
import { Route as DashboardRouteRouteImport } from './conf/_dashboard.route'
import { Route as AuthRouteRouteImport } from './conf/_auth.route'
import { Route as IndexRouteRouteImport } from './conf/index.route'
import { Route as DashboardLeaderboardRouteRouteImport } from './conf/_dashboard/leaderboard.route'
import { Route as DashboardAuthenticatedRouteRouteImport } from './conf/_dashboard/_authenticated.route'
import { Route as AuthRegisterRouteRouteImport } from './conf/_auth/register.route'
import { Route as AuthLogoutRouteRouteImport } from './conf/_auth/logout.route'
import { Route as AuthLoginRouteRouteImport } from './conf/_auth/login.route'
import { Route as DashboardSystemsIndexRouteRouteImport } from './conf/_dashboard/systems/index.route'
import { Route as DashboardAgentsIndexRouteRouteImport } from './conf/_dashboard/agents/index.route'
import { Route as DashboardAgentsAgentSymbolRouteRouteImport } from './conf/_dashboard/agents/$agentSymbol.route'
import { Route as DashboardAuthenticatedSurveysRouteRouteImport } from './conf/_dashboard/_authenticated/surveys.route'
import { Route as DashboardAuthenticatedFleetRouteRouteImport } from './conf/_dashboard/_authenticated/fleet.route'
import { Route as DashboardAuthenticatedContractsRouteRouteImport } from './conf/_dashboard/_authenticated/contracts.route'
import { Route as DashboardSystemsSystemSymbolIndexRouteRouteImport } from './conf/_dashboard/systems/$systemSymbol/index.route'
import { Route as DashboardAuthenticatedFleetIndexRouteRouteImport } from './conf/_dashboard/_authenticated/fleet/index.route'
import { Route as DashboardAuthenticatedFleetShipSymbolRouteRouteImport } from './conf/_dashboard/_authenticated/fleet/$shipSymbol.route'
import { Route as DashboardSystemsSystemSymbolWaypointWaypointSymbolRouteRouteImport } from './conf/_dashboard/systems/$systemSymbol/waypoint/$waypointSymbol.route'
import { Route as DashboardAuthenticatedFleetShipSymbolOverlayRouteRouteImport } from './conf/_dashboard/_authenticated/fleet/$shipSymbol/_overlay.route'
import { Route as DashboardAuthenticatedFleetShipSymbolOverlayMarketRouteRouteImport } from './conf/_dashboard/_authenticated/fleet/$shipSymbol/_overlay.market.route'

const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./conf/_dashboard.lazy').then((d) => d.Route))
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRouteRoute = IndexRouteRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardLeaderboardRouteRoute =
  DashboardLeaderboardRouteRouteImport.update({
    id: '/leaderboard',
    path: '/leaderboard',
    getParentRoute: () => DashboardRouteRoute,
  } as any).lazy(() =>
    import('./conf/_dashboard/leaderboard.lazy').then((d) => d.Route),
  )
const DashboardAuthenticatedRouteRoute =
  DashboardAuthenticatedRouteRouteImport.update({
    id: '/_authenticated',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const AuthRegisterRouteRoute = AuthRegisterRouteRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() => import('./conf/_auth/register.lazy').then((d) => d.Route))
const AuthLogoutRouteRoute = AuthLogoutRouteRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthLoginRouteRoute = AuthLoginRouteRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() => import('./conf/_auth/login.lazy').then((d) => d.Route))
const DashboardSystemsIndexRouteRoute =
  DashboardSystemsIndexRouteRouteImport.update({
    id: '/systems/',
    path: '/systems/',
    getParentRoute: () => DashboardRouteRoute,
  } as any).lazy(() =>
    import('./conf/_dashboard/systems/index.lazy').then((d) => d.Route),
  )
const DashboardAgentsIndexRouteRoute =
  DashboardAgentsIndexRouteRouteImport.update({
    id: '/agents/',
    path: '/agents/',
    getParentRoute: () => DashboardRouteRoute,
  } as any).lazy(() =>
    import('./conf/_dashboard/agents/index.lazy').then((d) => d.Route),
  )
const DashboardAgentsAgentSymbolRouteRoute =
  DashboardAgentsAgentSymbolRouteRouteImport.update({
    id: '/agents/$agentSymbol',
    path: '/agents/$agentSymbol',
    getParentRoute: () => DashboardRouteRoute,
  } as any).lazy(() =>
    import('./conf/_dashboard/agents/$agentSymbol.lazy').then((d) => d.Route),
  )
const DashboardAuthenticatedSurveysRouteRoute =
  DashboardAuthenticatedSurveysRouteRouteImport.update({
    id: '/surveys',
    path: '/surveys',
    getParentRoute: () => DashboardAuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./conf/_dashboard/_authenticated/surveys.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardAuthenticatedFleetRouteRoute =
  DashboardAuthenticatedFleetRouteRouteImport.update({
    id: '/fleet',
    path: '/fleet',
    getParentRoute: () => DashboardAuthenticatedRouteRoute,
  } as any)
const DashboardAuthenticatedContractsRouteRoute =
  DashboardAuthenticatedContractsRouteRouteImport.update({
    id: '/contracts',
    path: '/contracts',
    getParentRoute: () => DashboardAuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./conf/_dashboard/_authenticated/contracts.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardSystemsSystemSymbolIndexRouteRoute =
  DashboardSystemsSystemSymbolIndexRouteRouteImport.update({
    id: '/systems/$systemSymbol/',
    path: '/systems/$systemSymbol/',
    getParentRoute: () => DashboardRouteRoute,
  } as any).lazy(() =>
    import('./conf/_dashboard/systems/$systemSymbol/index.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardAuthenticatedFleetIndexRouteRoute =
  DashboardAuthenticatedFleetIndexRouteRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardAuthenticatedFleetRouteRoute,
  } as any).lazy(() =>
    import('./conf/_dashboard/_authenticated/fleet/index.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardAuthenticatedFleetShipSymbolRouteRoute =
  DashboardAuthenticatedFleetShipSymbolRouteRouteImport.update({
    id: '/$shipSymbol',
    path: '/$shipSymbol',
    getParentRoute: () => DashboardAuthenticatedFleetRouteRoute,
  } as any).lazy(() =>
    import('./conf/_dashboard/_authenticated/fleet/$shipSymbol.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardSystemsSystemSymbolWaypointWaypointSymbolRouteRoute =
  DashboardSystemsSystemSymbolWaypointWaypointSymbolRouteRouteImport.update({
    id: '/systems/$systemSymbol/waypoint/$waypointSymbol',
    path: '/systems/$systemSymbol/waypoint/$waypointSymbol',
    getParentRoute: () => DashboardRouteRoute,
  } as any).lazy(() =>
    import(
      './conf/_dashboard/systems/$systemSymbol/waypoint/$waypointSymbol.lazy'
    ).then((d) => d.Route),
  )
const DashboardAuthenticatedFleetShipSymbolOverlayRouteRoute =
  DashboardAuthenticatedFleetShipSymbolOverlayRouteRouteImport.update({
    id: '/_overlay',
    getParentRoute: () => DashboardAuthenticatedFleetShipSymbolRouteRoute,
  } as any).lazy(() =>
    import(
      './conf/_dashboard/_authenticated/fleet/$shipSymbol/_overlay.lazy'
    ).then((d) => d.Route),
  )
const DashboardAuthenticatedFleetShipSymbolOverlayMarketRouteRoute =
  DashboardAuthenticatedFleetShipSymbolOverlayMarketRouteRouteImport.update({
    id: '/market',
    path: '/market',
    getParentRoute: () =>
      DashboardAuthenticatedFleetShipSymbolOverlayRouteRoute,
  } as any).lazy(() =>
    import(
      './conf/_dashboard/_authenticated/fleet/$shipSymbol/_overlay.market.lazy'
    ).then((d) => d.Route),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRouteRoute
  '/login': typeof AuthLoginRouteRoute
  '/logout': typeof AuthLogoutRouteRoute
  '/register': typeof AuthRegisterRouteRoute
  '/leaderboard': typeof DashboardLeaderboardRouteRoute
  '/contracts': typeof DashboardAuthenticatedContractsRouteRoute
  '/fleet': typeof DashboardAuthenticatedFleetRouteRouteWithChildren
  '/surveys': typeof DashboardAuthenticatedSurveysRouteRoute
  '/agents/$agentSymbol': typeof DashboardAgentsAgentSymbolRouteRoute
  '/agents': typeof DashboardAgentsIndexRouteRoute
  '/systems': typeof DashboardSystemsIndexRouteRoute
  '/fleet/$shipSymbol': typeof DashboardAuthenticatedFleetShipSymbolOverlayRouteRouteWithChildren
  '/fleet/': typeof DashboardAuthenticatedFleetIndexRouteRoute
  '/systems/$systemSymbol': typeof DashboardSystemsSystemSymbolIndexRouteRoute
  '/systems/$systemSymbol/waypoint/$waypointSymbol': typeof DashboardSystemsSystemSymbolWaypointWaypointSymbolRouteRoute
  '/fleet/$shipSymbol/market': typeof DashboardAuthenticatedFleetShipSymbolOverlayMarketRouteRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRouteRoute
  '/login': typeof AuthLoginRouteRoute
  '/logout': typeof AuthLogoutRouteRoute
  '/register': typeof AuthRegisterRouteRoute
  '/leaderboard': typeof DashboardLeaderboardRouteRoute
  '/contracts': typeof DashboardAuthenticatedContractsRouteRoute
  '/surveys': typeof DashboardAuthenticatedSurveysRouteRoute
  '/agents/$agentSymbol': typeof DashboardAgentsAgentSymbolRouteRoute
  '/agents': typeof DashboardAgentsIndexRouteRoute
  '/systems': typeof DashboardSystemsIndexRouteRoute
  '/fleet/$shipSymbol': typeof DashboardAuthenticatedFleetShipSymbolOverlayRouteRouteWithChildren
  '/fleet': typeof DashboardAuthenticatedFleetIndexRouteRoute
  '/systems/$systemSymbol': typeof DashboardSystemsSystemSymbolIndexRouteRoute
  '/systems/$systemSymbol/waypoint/$waypointSymbol': typeof DashboardSystemsSystemSymbolWaypointWaypointSymbolRouteRoute
  '/fleet/$shipSymbol/market': typeof DashboardAuthenticatedFleetShipSymbolOverlayMarketRouteRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRouteRoute
  '/_auth': typeof AuthRouteRouteWithChildren
  '/_dashboard': typeof DashboardRouteRouteWithChildren
  '/_auth/login': typeof AuthLoginRouteRoute
  '/_auth/logout': typeof AuthLogoutRouteRoute
  '/_auth/register': typeof AuthRegisterRouteRoute
  '/_dashboard/_authenticated': typeof DashboardAuthenticatedRouteRouteWithChildren
  '/_dashboard/leaderboard': typeof DashboardLeaderboardRouteRoute
  '/_dashboard/_authenticated/contracts': typeof DashboardAuthenticatedContractsRouteRoute
  '/_dashboard/_authenticated/fleet': typeof DashboardAuthenticatedFleetRouteRouteWithChildren
  '/_dashboard/_authenticated/surveys': typeof DashboardAuthenticatedSurveysRouteRoute
  '/_dashboard/agents/$agentSymbol': typeof DashboardAgentsAgentSymbolRouteRoute
  '/_dashboard/agents/': typeof DashboardAgentsIndexRouteRoute
  '/_dashboard/systems/': typeof DashboardSystemsIndexRouteRoute
  '/_dashboard/_authenticated/fleet/$shipSymbol': typeof DashboardAuthenticatedFleetShipSymbolRouteRouteWithChildren
  '/_dashboard/_authenticated/fleet/': typeof DashboardAuthenticatedFleetIndexRouteRoute
  '/_dashboard/systems/$systemSymbol/': typeof DashboardSystemsSystemSymbolIndexRouteRoute
  '/_dashboard/_authenticated/fleet/$shipSymbol/_overlay': typeof DashboardAuthenticatedFleetShipSymbolOverlayRouteRouteWithChildren
  '/_dashboard/systems/$systemSymbol/waypoint/$waypointSymbol': typeof DashboardSystemsSystemSymbolWaypointWaypointSymbolRouteRoute
  '/_dashboard/_authenticated/fleet/$shipSymbol/_overlay/market': typeof DashboardAuthenticatedFleetShipSymbolOverlayMarketRouteRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/logout'
    | '/register'
    | '/leaderboard'
    | '/contracts'
    | '/fleet'
    | '/surveys'
    | '/agents/$agentSymbol'
    | '/agents'
    | '/systems'
    | '/fleet/$shipSymbol'
    | '/fleet/'
    | '/systems/$systemSymbol'
    | '/systems/$systemSymbol/waypoint/$waypointSymbol'
    | '/fleet/$shipSymbol/market'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/logout'
    | '/register'
    | '/leaderboard'
    | '/contracts'
    | '/surveys'
    | '/agents/$agentSymbol'
    | '/agents'
    | '/systems'
    | '/fleet/$shipSymbol'
    | '/fleet'
    | '/systems/$systemSymbol'
    | '/systems/$systemSymbol/waypoint/$waypointSymbol'
    | '/fleet/$shipSymbol/market'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_dashboard'
    | '/_auth/login'
    | '/_auth/logout'
    | '/_auth/register'
    | '/_dashboard/_authenticated'
    | '/_dashboard/leaderboard'
    | '/_dashboard/_authenticated/contracts'
    | '/_dashboard/_authenticated/fleet'
    | '/_dashboard/_authenticated/surveys'
    | '/_dashboard/agents/$agentSymbol'
    | '/_dashboard/agents/'
    | '/_dashboard/systems/'
    | '/_dashboard/_authenticated/fleet/$shipSymbol'
    | '/_dashboard/_authenticated/fleet/'
    | '/_dashboard/systems/$systemSymbol/'
    | '/_dashboard/_authenticated/fleet/$shipSymbol/_overlay'
    | '/_dashboard/systems/$systemSymbol/waypoint/$waypointSymbol'
    | '/_dashboard/_authenticated/fleet/$shipSymbol/_overlay/market'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRouteRoute: typeof IndexRouteRoute
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/leaderboard': {
      id: '/_dashboard/leaderboard'
      path: '/leaderboard'
      fullPath: '/leaderboard'
      preLoaderRoute: typeof DashboardLeaderboardRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/_authenticated': {
      id: '/_dashboard/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof DashboardAuthenticatedRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_auth/register': {
      id: '/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/logout': {
      id: '/_auth/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof AuthLogoutRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_dashboard/systems/': {
      id: '/_dashboard/systems/'
      path: '/systems'
      fullPath: '/systems'
      preLoaderRoute: typeof DashboardSystemsIndexRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/agents/': {
      id: '/_dashboard/agents/'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof DashboardAgentsIndexRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/agents/$agentSymbol': {
      id: '/_dashboard/agents/$agentSymbol'
      path: '/agents/$agentSymbol'
      fullPath: '/agents/$agentSymbol'
      preLoaderRoute: typeof DashboardAgentsAgentSymbolRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/_authenticated/surveys': {
      id: '/_dashboard/_authenticated/surveys'
      path: '/surveys'
      fullPath: '/surveys'
      preLoaderRoute: typeof DashboardAuthenticatedSurveysRouteRouteImport
      parentRoute: typeof DashboardAuthenticatedRouteRoute
    }
    '/_dashboard/_authenticated/fleet': {
      id: '/_dashboard/_authenticated/fleet'
      path: '/fleet'
      fullPath: '/fleet'
      preLoaderRoute: typeof DashboardAuthenticatedFleetRouteRouteImport
      parentRoute: typeof DashboardAuthenticatedRouteRoute
    }
    '/_dashboard/_authenticated/contracts': {
      id: '/_dashboard/_authenticated/contracts'
      path: '/contracts'
      fullPath: '/contracts'
      preLoaderRoute: typeof DashboardAuthenticatedContractsRouteRouteImport
      parentRoute: typeof DashboardAuthenticatedRouteRoute
    }
    '/_dashboard/systems/$systemSymbol/': {
      id: '/_dashboard/systems/$systemSymbol/'
      path: '/systems/$systemSymbol'
      fullPath: '/systems/$systemSymbol'
      preLoaderRoute: typeof DashboardSystemsSystemSymbolIndexRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/_authenticated/fleet/': {
      id: '/_dashboard/_authenticated/fleet/'
      path: '/'
      fullPath: '/fleet/'
      preLoaderRoute: typeof DashboardAuthenticatedFleetIndexRouteRouteImport
      parentRoute: typeof DashboardAuthenticatedFleetRouteRoute
    }
    '/_dashboard/_authenticated/fleet/$shipSymbol': {
      id: '/_dashboard/_authenticated/fleet/$shipSymbol'
      path: '/$shipSymbol'
      fullPath: '/fleet/$shipSymbol'
      preLoaderRoute: typeof DashboardAuthenticatedFleetShipSymbolRouteRouteImport
      parentRoute: typeof DashboardAuthenticatedFleetRouteRoute
    }
    '/_dashboard/systems/$systemSymbol/waypoint/$waypointSymbol': {
      id: '/_dashboard/systems/$systemSymbol/waypoint/$waypointSymbol'
      path: '/systems/$systemSymbol/waypoint/$waypointSymbol'
      fullPath: '/systems/$systemSymbol/waypoint/$waypointSymbol'
      preLoaderRoute: typeof DashboardSystemsSystemSymbolWaypointWaypointSymbolRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/_authenticated/fleet/$shipSymbol/_overlay': {
      id: '/_dashboard/_authenticated/fleet/$shipSymbol/_overlay'
      path: ''
      fullPath: '/fleet/$shipSymbol'
      preLoaderRoute: typeof DashboardAuthenticatedFleetShipSymbolOverlayRouteRouteImport
      parentRoute: typeof DashboardAuthenticatedFleetShipSymbolRouteRoute
    }
    '/_dashboard/_authenticated/fleet/$shipSymbol/_overlay/market': {
      id: '/_dashboard/_authenticated/fleet/$shipSymbol/_overlay/market'
      path: '/market'
      fullPath: '/fleet/$shipSymbol/market'
      preLoaderRoute: typeof DashboardAuthenticatedFleetShipSymbolOverlayMarketRouteRouteImport
      parentRoute: typeof DashboardAuthenticatedFleetShipSymbolOverlayRouteRoute
    }
  }
}

interface AuthRouteRouteChildren {
  AuthLoginRouteRoute: typeof AuthLoginRouteRoute
  AuthLogoutRouteRoute: typeof AuthLogoutRouteRoute
  AuthRegisterRouteRoute: typeof AuthRegisterRouteRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthLoginRouteRoute: AuthLoginRouteRoute,
  AuthLogoutRouteRoute: AuthLogoutRouteRoute,
  AuthRegisterRouteRoute: AuthRegisterRouteRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface DashboardAuthenticatedFleetShipSymbolOverlayRouteRouteChildren {
  DashboardAuthenticatedFleetShipSymbolOverlayMarketRouteRoute: typeof DashboardAuthenticatedFleetShipSymbolOverlayMarketRouteRoute
}

const DashboardAuthenticatedFleetShipSymbolOverlayRouteRouteChildren: DashboardAuthenticatedFleetShipSymbolOverlayRouteRouteChildren =
  {
    DashboardAuthenticatedFleetShipSymbolOverlayMarketRouteRoute:
      DashboardAuthenticatedFleetShipSymbolOverlayMarketRouteRoute,
  }

const DashboardAuthenticatedFleetShipSymbolOverlayRouteRouteWithChildren =
  DashboardAuthenticatedFleetShipSymbolOverlayRouteRoute._addFileChildren(
    DashboardAuthenticatedFleetShipSymbolOverlayRouteRouteChildren,
  )

interface DashboardAuthenticatedFleetShipSymbolRouteRouteChildren {
  DashboardAuthenticatedFleetShipSymbolOverlayRouteRoute: typeof DashboardAuthenticatedFleetShipSymbolOverlayRouteRouteWithChildren
}

const DashboardAuthenticatedFleetShipSymbolRouteRouteChildren: DashboardAuthenticatedFleetShipSymbolRouteRouteChildren =
  {
    DashboardAuthenticatedFleetShipSymbolOverlayRouteRoute:
      DashboardAuthenticatedFleetShipSymbolOverlayRouteRouteWithChildren,
  }

const DashboardAuthenticatedFleetShipSymbolRouteRouteWithChildren =
  DashboardAuthenticatedFleetShipSymbolRouteRoute._addFileChildren(
    DashboardAuthenticatedFleetShipSymbolRouteRouteChildren,
  )

interface DashboardAuthenticatedFleetRouteRouteChildren {
  DashboardAuthenticatedFleetShipSymbolRouteRoute: typeof DashboardAuthenticatedFleetShipSymbolRouteRouteWithChildren
  DashboardAuthenticatedFleetIndexRouteRoute: typeof DashboardAuthenticatedFleetIndexRouteRoute
}

const DashboardAuthenticatedFleetRouteRouteChildren: DashboardAuthenticatedFleetRouteRouteChildren =
  {
    DashboardAuthenticatedFleetShipSymbolRouteRoute:
      DashboardAuthenticatedFleetShipSymbolRouteRouteWithChildren,
    DashboardAuthenticatedFleetIndexRouteRoute:
      DashboardAuthenticatedFleetIndexRouteRoute,
  }

const DashboardAuthenticatedFleetRouteRouteWithChildren =
  DashboardAuthenticatedFleetRouteRoute._addFileChildren(
    DashboardAuthenticatedFleetRouteRouteChildren,
  )

interface DashboardAuthenticatedRouteRouteChildren {
  DashboardAuthenticatedContractsRouteRoute: typeof DashboardAuthenticatedContractsRouteRoute
  DashboardAuthenticatedFleetRouteRoute: typeof DashboardAuthenticatedFleetRouteRouteWithChildren
  DashboardAuthenticatedSurveysRouteRoute: typeof DashboardAuthenticatedSurveysRouteRoute
}

const DashboardAuthenticatedRouteRouteChildren: DashboardAuthenticatedRouteRouteChildren =
  {
    DashboardAuthenticatedContractsRouteRoute:
      DashboardAuthenticatedContractsRouteRoute,
    DashboardAuthenticatedFleetRouteRoute:
      DashboardAuthenticatedFleetRouteRouteWithChildren,
    DashboardAuthenticatedSurveysRouteRoute:
      DashboardAuthenticatedSurveysRouteRoute,
  }

const DashboardAuthenticatedRouteRouteWithChildren =
  DashboardAuthenticatedRouteRoute._addFileChildren(
    DashboardAuthenticatedRouteRouteChildren,
  )

interface DashboardRouteRouteChildren {
  DashboardAuthenticatedRouteRoute: typeof DashboardAuthenticatedRouteRouteWithChildren
  DashboardLeaderboardRouteRoute: typeof DashboardLeaderboardRouteRoute
  DashboardAgentsAgentSymbolRouteRoute: typeof DashboardAgentsAgentSymbolRouteRoute
  DashboardAgentsIndexRouteRoute: typeof DashboardAgentsIndexRouteRoute
  DashboardSystemsIndexRouteRoute: typeof DashboardSystemsIndexRouteRoute
  DashboardSystemsSystemSymbolIndexRouteRoute: typeof DashboardSystemsSystemSymbolIndexRouteRoute
  DashboardSystemsSystemSymbolWaypointWaypointSymbolRouteRoute: typeof DashboardSystemsSystemSymbolWaypointWaypointSymbolRouteRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardAuthenticatedRouteRoute:
    DashboardAuthenticatedRouteRouteWithChildren,
  DashboardLeaderboardRouteRoute: DashboardLeaderboardRouteRoute,
  DashboardAgentsAgentSymbolRouteRoute: DashboardAgentsAgentSymbolRouteRoute,
  DashboardAgentsIndexRouteRoute: DashboardAgentsIndexRouteRoute,
  DashboardSystemsIndexRouteRoute: DashboardSystemsIndexRouteRoute,
  DashboardSystemsSystemSymbolIndexRouteRoute:
    DashboardSystemsSystemSymbolIndexRouteRoute,
  DashboardSystemsSystemSymbolWaypointWaypointSymbolRouteRoute:
    DashboardSystemsSystemSymbolWaypointWaypointSymbolRouteRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRouteRoute: IndexRouteRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
